import { Card, CardContent } from "@/shared/ui/card";

import type { GeoReport } from "../../../api/geoService";

/** 信源阵地体检:AI 从哪找资料,你就该在哪有阵地。红灯 = 缺席(带竞对对照)。 */
export function PresenceChecklist({ report }: { report: GeoReport }) {
  const presence = report.platform_presence;
  if (!presence?.available || !presence.items?.length) return null;
  const gapByKey = new Map((presence.competitor_gaps ?? []).map((g) => [g.key, g] as const));
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-sm font-medium">信源阵地体检</div>
        <div className="mt-1 text-xs text-muted-foreground">
          AI 回答时优先引用这些平台 —— 红灯 = 你在该阵地缺席
        </div>
        <div className="mt-3 space-y-2" data-testid="geo-presence-list">
          {presence.items.map((item) => {
            const gap = gapByKey.get(item.key);
            return (
              <div
                key={item.key}
                className="flex items-center gap-3 rounded-lg border border-border/60 bg-muted/30 px-3 py-2 text-sm"
              >
                <span
                  aria-label={item.present ? "已有阵地" : "缺席"}
                  className={`h-2.5 w-2.5 shrink-0 rounded-full ${
                    item.present
                      ? "bg-emerald-500 shadow-[0_0_6px_rgba(16,185,129,.6)]"
                      : "bg-rose-500 shadow-[0_0_6px_rgba(244,63,94,.5)]"
                  }`}
                />
                <span className="w-20 shrink-0 font-medium">{item.label}</span>
                <span className="min-w-0 flex-1 truncate text-xs text-muted-foreground">
                  {item.present ? (
                    item.evidence_url ? (
                      <a
                        href={item.evidence_url}
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-primary hover:underline"
                      >
                        {item.evidence_title || item.evidence_url}
                      </a>
                    ) : (
                      "已有阵地"
                    )
                  ) : gap ? (
                    <span>
                      无阵地 · <span className="text-amber-500">对手 {gap.competitor} 有</span>
                    </span>
                  ) : (
                    "无阵地"
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
